import React, { useEffect, useRef } from "react";
import anime from "animejs";
import _ from "lodash";
import "./StarEffect.css";

const StarEffect = () => {
    const containerRef = useRef(null);
    const sparks = useRef([]);
    const sparksIndex = useRef(0);

    const sparkCount = 50; // Reduced from 100
    const sparkParticleCount = 6; // Reduced from 6

    const lerp = (p1, p2, t) => p1 + (p2 - p1) * t;

    const ease = {
        outQuad: (t) => t * (2 - t),
    };

    const circularRandom = (r) => {
        r = r * Math.sqrt(Math.abs(Math.random() - Math.random()));
        const theta = Math.random() * 2 * Math.PI;
        return {
            x: r * Math.cos(theta),
            y: r * Math.sin(theta),
            r,
        };
    };

    useEffect(() => {
        const container = containerRef.current;

        for (let i = 0; i < sparkCount; i++) {
            const spark = { els: [] };

            for (let j = 0; j < sparkParticleCount; j++) {
                const dot = document.createElement("div");
                dot.classList.add("dot");
                container.appendChild(dot);
                spark.els.push(dot);

                const particleSize = anime.random(5, 15); // Reduced size
                const sparkRadius = 15; // Reduced radius
                const { x, y, r } = circularRandom(sparkRadius);

                dot.style.width = `${lerp(particleSize, 1, ease.outQuad(r / sparkRadius))}px`;
                dot.style.height = `${lerp(particleSize, 1, ease.outQuad(r / sparkRadius))}px`;
                dot.style.opacity = "0";
                dot.style.transform = `translateX(${x}px) translateY(${y}px)`;
            }

            spark.anime = anime({
                targets: spark.els,
                loop: false,
                easing: "linear",
                autoplay: false,
                delay: anime.stagger(16), // Increased delay
                opacity: [
                    { value: 0, duration: 0 },
                    { value: 1, duration: 100 }, // Longer fade-in
                    { value: 0, duration: () => anime.random(400, 600) }, // Reduced fade-out
                ],
                width: { value: 2, duration: 400 },
                height: { value: 2, duration: 400 },
                translateX: {
                    value: () => anime.random(-20, 20),
                    duration: 600,
                },
                translateY: {
                    value: () => anime.random(-20, 20),
                    duration: 600,
                },
            });

            sparks.current.push(spark);
        }

        const throttledHandleMouseMove = _.throttle((e) => {
            anime.set(sparks.current[sparksIndex.current].els, {
                left: e.pageX,
                top: e.pageY,
            });
            sparks.current[sparksIndex.current].anime.restart();
            sparksIndex.current = (sparksIndex.current + 1) % sparks.current.length;
        }, 100); // Throttled to fire every 100ms

        window.addEventListener("mousemove", throttledHandleMouseMove);

        return () => {
            window.removeEventListener("mousemove", throttledHandleMouseMove);
        };
    }, []);

    return <div ref={containerRef} className="anime-container"></div>;
};

export default StarEffect;
